import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js';
import share from '@/components/share'; // 引入wxjs

import wx from "weixin-js-sdk";
export default {
  components: {
    share: share
  },
  data: function data() {
    return {
      ceshi: '',
      shareData: {
        title: '',
        imageurl: '',
        goalurl: '',
        description: ''
      },
      //分享数据
      appId: "",
      // 必填，公众号的唯一标识
      timestamp: "",
      // 必填，生成签名的时间戳
      nonceStr: "",
      // 必填，生成签名的随机串
      signature: "",
      // 必填，签名，见附录1
      lineLink: '',
      //分享的网页,地址完整地址如:https://xxx.com/xxx/xxx.html
      bwidth: true,
      //表单宽度
      phoneShow: true,
      //二维码状态
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      radioShow: false,
      radio: false,
      //单选按钮
      shData1: [{
        name: 'ERSA',
        value: 1
      }, {
        name: 'HELLER',
        value: 2
      }, {
        name: 'BTU',
        value: 3
      }, {
        name: 'REHM',
        value: 4
      }, {
        name: '劲拓',
        value: 5
      }, {
        name: '浩宝',
        value: 6
      }, {
        name: '日东',
        value: 7
      }],
      //回流炉是什么品牌
      shData2: ['回流焊', '氮气回流焊', '真空回流焊', '垂直炉', '波峰焊', '全隧道氮气波峰焊', '选择性波峰焊'],
      //第2题多选
      shData4: ['EMS电子制造', '能源储能', '半导体', '汽车电子', '太阳能光伏', '军工产品', '电子通讯'],
      //第4题
      shData5: ['控温精度', '热补偿能力', '冷却能力', '加热效率', '温度均匀性', '残氧量控制', '风量分区控制', '轨道振动/形变', 'MES数据收集对接', '炉子的稳定性', '炉内横向温差', '链速速度设置'],
      //第5题
      shData6: ['掉件、锡裂', '虚焊、冷焊、假焊', '残留气泡', '不定期焊点发黑', '严重偏位', 'BGA焊接不良', 'QFN焊接不良', '连接器焊接不良', '片式元件（Chip）虚焊、立碑、锡珠', '飞件、缺件'],
      //第6题
      shData7: ['卡板', '测试过程繁琐，千遍一律', '测温板制作困难，成本较高', '统计困难，炉子实时稳定性无法监测', '如何快速调试出最优的温度曲线', '松香回收系统功能不强造成炉子滴油', '焊接大热容量器件容易造成冷焊', '焊接微小元件容易造成位移', '双面板产品偶尔掉件', '残氧量数据波动幅度大，不稳定', '预热区和焊接区温差不够大', '品质问题不断，找原因无从下手', '温区风量无法精确控制，导致温度曲线不精准', '冷却区的冷却斜率无法根据产品调整'],
      //第7题
      shData8: ['测温板制作标准', '测温板选点依据', '温度曲线设置标准', '灯芯效应解决方案', '飞件解决方案', '掉件解决方案', '锡珠解决方案', '立碑解决方案', '元件偏移解决方案', '冷焊解决方案', '炸锡解决方案', '焊点气泡解决方案', 'BGA HiP解决方案', 'BGA空焊解决方案', 'PCB拒焊解决方案', '元件端子不上锡解决方案', 'QFN虚焊/QFN短路解决方案', '功能模块焊接解决方案', '通孔回流焊工艺', '设备维护保养'],
      //第八题
      shData9: ['回流焊设备硬件定期检查、校准', '设备的工艺能力的定期体检', '回流焊实时cpk监控', '回流焊接工艺驻场培训', '回流焊接工艺视频课程学习', '回流焊工艺现场诊断、答疑、培训', '回流焊实时温度监控'],
      dx: {
        //多选
        multiplechoice1: [],
        //第一题多选
        multiplechoice2: [],
        //第七题多选
        multiplechoice3: [],
        //第八题多选
        multiplechoice4: [],
        //第九题多选
        multiplechoice5: [],
        //第一题多选
        multiplechoice6: [],
        //第七题多选
        multiplechoice7: [],
        //第八题多选
        multiplechoice8: [] //第八题多选

      },
      tk: {
        suggestions1: '',
        //填空1
        suggestions2: '',
        //填空2
        suggestions3: '',
        //填空3
        suggestions4: '',
        //填空4
        suggestions5: '',
        //填空5
        suggestions6: '',
        //填空6
        suggestions7: '',
        //填空7
        suggestions8: '' //填空8

      },
      bus: {
        type: 3,
        //RCMK调查表
        company: '',
        //公司
        email: '',
        //邮箱
        contact: '',
        //联系人
        position: '',
        //职务
        phone: '',
        //联系电话
        multiplechoice1: '',
        //第一题多选
        multiplechoice2: '',
        //第七题多选
        multiplechoice3: '',
        //第八题多选
        multiplechoice4: '',
        //第九题多选
        multiplechoice5: '',
        //第七题多选
        multiplechoice6: '',
        //第八题多选
        multiplechoice7: '',
        //第九题多选
        multiplechoice8: '',
        //第九题多选
        func: '',
        //单选1第二题
        stability: '' //单选二第三题

      },
      rcmklog: {
        ip: '',
        iparea: '',
        mac: '',
        description: 'RCMK调查问卷'
      },
      qyData: [{
        name: "北京",
        selected: false,
        value: 1,
        lowercaseName: "beijing"
      }, {
        name: "天津",
        selected: false,
        value: 2,
        lowercaseName: "tianjin"
      }, {
        name: "上海",
        selected: false,
        value: 3,
        lowercaseName: "shanghai"
      }, {
        name: "重庆",
        selected: false,
        value: 4,
        lowercaseName: "chongqing"
      }, {
        name: "河北",
        selected: false,
        value: 5,
        lowercaseName: "hebei"
      }, {
        name: "河南",
        selected: false,
        value: 6,
        lowercaseName: "henan"
      }, {
        name: "云南",
        selected: false,
        value: 7,
        lowercaseName: "yunnan"
      }, {
        name: "辽宁",
        selected: false,
        value: 8,
        lowercaseName: "liaoning"
      }, {
        name: "黑龙江",
        selected: false,
        value: 9,
        lowercaseName: "heilongjiang"
      }, {
        name: "湖南",
        selected: false,
        value: 10,
        lowercaseName: "hunan"
      }, {
        name: "安徽",
        selected: false,
        value: 11,
        lowercaseName: "anhui"
      }, {
        name: "山东",
        selected: false,
        value: 12,
        lowercaseName: "shandong"
      }, {
        name: "新疆",
        selected: false,
        value: 13,
        lowercaseName: "xinjiang"
      }, {
        name: "江苏",
        selected: false,
        value: 14,
        lowercaseName: "jiangsu"
      }, {
        name: "浙江",
        selected: false,
        value: 15,
        lowercaseName: "zhejiang"
      }, {
        name: "江西",
        selected: false,
        value: 16,
        lowercaseName: "jiangxi"
      }, {
        name: "湖北",
        selected: false,
        value: 17,
        lowercaseName: "hubei"
      }, {
        name: "广西",
        selected: false,
        value: 18,
        lowercaseName: "guangxi"
      }, {
        name: "甘肃",
        selected: false,
        value: 19,
        lowercaseName: "gansu"
      }, {
        name: "山西",
        selected: false,
        value: 20,
        lowercaseName: "shanxi"
      }, {
        name: "内蒙古",
        selected: false,
        value: 21,
        lowercaseName: "neimenggu"
      }, {
        name: "陕西",
        selected: false,
        value: 22,
        lowercaseName: "shanxi"
      }, {
        name: "吉林",
        selected: false,
        value: 23,
        lowercaseName: "jilin"
      }, {
        name: "福建",
        selected: false,
        value: 24,
        lowercaseName: "fujian"
      }, {
        name: "贵州",
        selected: false,
        value: 25,
        lowercaseName: "guizhou"
      }, {
        name: "广东",
        selected: false,
        value: 26,
        lowercaseName: "guangdong"
      }, {
        name: "青海",
        selected: false,
        value: 27,
        lowercaseName: "qinghai"
      }, {
        name: "西藏",
        selected: false,
        value: 28,
        lowercaseName: "xizang"
      }, {
        name: "四川",
        selected: false,
        value: 29,
        lowercaseName: "sichuan"
      }, {
        name: "宁夏",
        selected: false,
        value: 30,
        lowercaseName: "ningxia"
      }, {
        name: "海南",
        selected: false,
        value: 31,
        lowercaseName: "hainan"
      }, {
        name: "台湾",
        selected: false,
        value: 32,
        lowercaseName: "taiwan"
      }, {
        name: "香港",
        selected: false,
        value: 33,
        lowercaseName: "hongkong"
      }, {
        name: "澳门",
        selected: false,
        value: 34,
        lowercaseName: "macau"
      }]
    };
  },
  created: function created() {
    // console.log(navigator.userAgent,'电脑信息');
    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      console.log('手机端');
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fo();

    this._isMobile(); //获取设备型号
    // this.getIpAddress()//获取ip及所在地
    // this.getShareInfo()
    // this.getCityByIP()


    setTimeout(function () {
      _this.ipList();
    }, 3000);
  },
  methods: {
    // 获取到的分享数据
    changes: function changes(e) {
      Object.assign(this.shareData, e);
      console.log(e, '获取到的分享数据');
    },
    //获取当前ip, 位置
    getIpAddress: function getIpAddress() {
      var _this2 = this;

      // return
      fetch("https://api.ipify.org?format=json").then(function (x) {
        return x.json();
      }).then(function (h) {
        _this2.getLocation(h.ip); // message({ type: "success", message: '当前IP'+h.ip });

      });
    },
    getLocation: function getLocation(ip) {
      var _this3 = this;

      // 使用IP地理位置API获取IP所在地
      this.rcmklog.ip = ip;
      var cityInEnglish = '';
      http.get('https://ipapi.co/json/').then(function (response) {
        console.log(response, '当前地址'); // cityInEnglish = response.data.region.toLowerCase(); // 转换城市名为小写
        // this.qyData.map(v=>{
        //     if(v.lowercaseName==cityInEnglish){
        //         this.rcmklog.iparea = v.name
        //     }
        // })

        _this3.rcmklog.iparea = "".concat(response.data.region, ", ").concat(response.data.city); // message({ type: "success", message: '当前城市'+this.rcmklog.iparea });
      }).catch(function (error) {
        console.error('Error fetching location:', error);
      });
    },
    getCityByIP: function getCityByIP() {
      http.get('/api/ip-location').then(function (response) {// this.city = response.data.city;
        // message({ type: "success", message: '当前IP'+response.data.city });
      }).catch(function (error) {
        console.error('获取IP地理位置失败:', error);
      });
    },
    // 判断是否是手机端，如果是，返回true
    _isMobile: function _isMobile() {
      var ua = window.navigator.userAgent.toLowerCase();
      var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

      if (flag) {
        if (ua.indexOf('wxwork') > -1) {
          this.rcmklog.mac = '手机企业微信';
        } else if (ua.indexOf('micromessenger') > -1) {
          this.rcmklog.mac = '手机微信';
        } else {
          this.rcmklog.mac = '手机其它设备';
        } // message({ type: "success", message: this.rcmklog.mac });

      } else {
        if (ua.indexOf('micromessenger') > -1) {
          this.rcmklog.mac = '电脑微信';
        } else {
          this.rcmklog.mac = '电脑其它设备';
        }
      }
    },
    // 保存当前访问者的信息数据
    ipList: function ipList() {
      console.log(this.rcmklog, '当前ip数据');
      http.post('/ksfpropagelog/save', this.rcmklog).then(function (res) {
        console.log(res, '保存数据');
      });
    },
    fo: function fo() {
      var _this4 = this;

      http.get('http://gitea.smtjhd.com/api/wx/getWXParam?url=http://gitea.smtjhd.com/survey/index.html').then(function (res) {
        var status = res.status,
            data = res.data;
        console.log(res, '获取微信参数');

        if (200 == status) {
          _this4.appId = data.appId;
          _this4.timestamp = data.timestamp;
          _this4.nonceStr = data.nonceStr;
          _this4.signature = data.signature;
          _this4.lineLink = 'http://gitea.smtjhd.com/survey/index.html';

          _this4.fo1();
        }
      });
    },
    fo1: function fo1() {
      var appId = this.appId,
          timestamp = this.timestamp,
          nonceStr = this.nonceStr,
          signature = this.signature,
          lineLink = this.lineLink;
      wx.config({
        debug: false,
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId,
        // 必填，公众号的唯一标识
        timestamp: timestamp,
        // 必填，生成签名的时间戳
        nonceStr: nonceStr,
        // 必填，生成签名的随机串
        signature: signature,
        // 必填，签名，见附录1
        jsApiList: ['updateAppMessageShareData', //分享给好友
        'updateTimelineShareData' //分享到朋友圈
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

      }); // let {description,imageurl,title,goalurl} = this.shareData

      var than = this;
      wx.ready(function () {
        var appId = than.appId,
            timestamp = than.timestamp,
            nonceStr = than.nonceStr,
            signature = than.signature,
            lineLink = than.lineLink; // than.ceshi+= 'appId'+appId+'timestamp'+timestamp+'nonceStr'+nonceStr+'signature'+signature+'lineLink'+lineLink

        console.log('准备进来了'); //自定义分享,小图标,标题,内容

        var imgUrl = "http://gitea.smtjhd.com/survey/300X300RCMK.jpg"; //(填写完整的图标地址)

        var shareTitle = "回流焊焊接系统诊断与对策问卷调研"; //回流焊焊接系统诊断与对策问卷调研

        var descContent = "回流焊焊接技术作为电子制造的关键环节，对产品质量和生产效率起着决定性的作用。为了进一步提升回流焊焊接技术的水平并推动行业的可持续发展， 我们诚挚地邀请您积极参与「回流焊焊接系统诊断与对策」"; // 配置分享给朋友

        wx.updateAppMessageShareData({
          title: shareTitle,
          desc: descContent,
          link: lineLink,
          imgUrl: imgUrl
        }); //分享到朋友圈

        wx.updateTimelineShareData({
          title: shareTitle,
          link: lineLink,
          imgUrl: imgUrl,
          success: function success(res) {
            wx.showToast({
              title: '分享成功'
            });
          },
          cancel: function cancel(res) {
            wx.showToast({
              title: '取消分享！'
            });
          },
          fail: function fail(res) {
            wx.showToast({
              title: '分享失败！！'
            });
          }
        });
      });
      wx.error(function (res) {// alert('返回的错误信息，'+res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    // 判断是否勾选了其它
    xz1: function xz1(e, index) {
      if (e == false) {
        this.tk.suggestions1 = '';
      }
    },
    xz2: function xz2(e) {
      console.log(e);

      if (e != '其它') {
        this.tk.suggestions2 = '';
      }
    },
    xz3: function xz3(e) {
      if (e == false) {
        this.tk.suggestions3 = '';
      }
    },
    xz4: function xz4(e) {
      if (e == false) {
        this.tk.suggestions4 = '';
      }
    },
    xz5: function xz5(e) {
      if (e == false) {
        this.tk.suggestions5 = '';
      }
    },
    xz6: function xz6(e) {
      if (e == false) {
        this.tk.suggestions6 = '';
      }
    },
    xz7: function xz7(e) {
      if (e == false) {
        this.tk.suggestions7 = '';
      }
    },
    xz8: function xz8(e) {
      if (e == false) {
        this.tk.suggestions8 = '';
      }
    },
    // 判断填空1是否有勾选其它
    tk1: function tk1() {
      var sun = true;
      this.dx.multiplechoice1.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空2是否有勾选其它
    tk2: function tk2() {
      var sun = true;

      if (this.bus.func == '其它') {
        sun = false;
      }

      return sun;
    },
    // 判断填空3是否有勾选其它
    tk3: function tk3() {
      var sun = true;
      this.dx.multiplechoice2.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk4: function tk4() {
      var sun = true;
      this.dx.multiplechoice3.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk5: function tk5() {
      var sun = true;
      this.dx.multiplechoice4.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk6: function tk6() {
      var sun = true;
      this.dx.multiplechoice5.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk7: function tk7() {
      var sun = true;
      this.dx.multiplechoice6.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk8: function tk8() {
      var sun = true;
      this.dx.multiplechoice8.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 点击显示图片
    tuShow: function tuShow() {
      this.imgStatus = true;
    },
    // 验证规则
    srule: function srule() {
      var _this$bus = this.bus,
          company = _this$bus.company,
          email = _this$bus.email,
          contact = _this$bus.contact,
          position = _this$bus.position,
          phone = _this$bus.phone,
          func = _this$bus.func,
          stability = _this$bus.stability; // 公司名称

      if (company == '') {
        message({
          type: "error",
          message: '公司名称不能为空'
        });
        return false;
      } // 联系人


      if (contact == '') {
        message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      } // 电话


      if (phone == '') {
        message({
          type: "error",
          message: '电话不能为空'
        });
        return false;
      } // 职位


      if (position == '') {
        message({
          type: "error",
          message: '职位不能为空'
        });
        return false;
      } // 邮箱


      if (email == '') {
        message({
          type: "error",
          message: '邮箱不能为空'
        });
        return false;
      } // 第1题


      if (this.dx.multiplechoice1.length == 0) {
        message({
          type: "error",
          message: '第1题不能为空'
        });
        return false;
      } // 第2题


      if (this.dx.multiplechoice8.length == 0) {
        message({
          type: "error",
          message: '第2题不能为空'
        });
        return false;
      } // 第3题


      if (func == '') {
        message({
          type: "error",
          message: '第3题不能为空'
        });
        return false;
      } // 第4题


      if (stability == '') {
        message({
          type: "error",
          message: '第4题不能为空'
        });
        return false;
      } // 第5题


      if (this.dx.multiplechoice2.length == 0) {
        message({
          type: "error",
          message: '第5题不能为空'
        });
        return false;
      } // 第6题


      if (this.dx.multiplechoice3.length == 0) {
        message({
          type: "error",
          message: '第6题不能为空'
        });
        return false;
      } // 第7题


      if (this.dx.multiplechoice4.length == 0) {
        message({
          type: "error",
          message: '第7题不能为空'
        });
        return false;
      } // 第8题


      if (this.dx.multiplechoice5.length == 0) {
        message({
          type: "error",
          message: '第8题不能为空'
        });
        return false;
      } // 第9题


      if (this.dx.multiplechoice6.length == 0) {
        message({
          type: "error",
          message: '第9题不能为空'
        });
        return false;
      } // 第10题


      if (this.dx.multiplechoice7.length == 0) {
        message({
          type: "error",
          message: '第10题不能为空'
        });
        return false;
      }

      return true;
    },
    duoxuan: function duoxuan() {
      var _this5 = this;

      if (this.bus.func == '其它') {
        this.bus.func = this.bus.func + this.tk.suggestions2 + '';
      }

      this.dx.multiplechoice1.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice1[i] = v + '-' + _this5.tk.suggestions1;
        }
      });
      this.dx.multiplechoice2.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice2[i] = v + '-' + _this5.tk.suggestions3;
        }
      });
      this.dx.multiplechoice3.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice3[i] = v + '-' + _this5.tk.suggestions4;
        }
      });
      this.dx.multiplechoice4.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice4[i] = v + '-' + _this5.tk.suggestions5;
        }
      });
      this.dx.multiplechoice5.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice5[i] = v + '-' + _this5.tk.suggestions6;
        }
      });
      this.dx.multiplechoice6.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice6[i] = v + '-' + _this5.tk.suggestions7;
        }
      });
      this.dx.multiplechoice8.map(function (v, i) {
        if (v == '其它') {
          _this5.dx.multiplechoice8[i] = v + '-' + _this5.tk.suggestions8;
        }
      });
    },
    // 点击提交
    busAdd: function busAdd() {
      var _this6 = this;

      if (!this.srule()) {
        return false;
      }

      this.duoxuan();
      this.bus.multiplechoice1 = this.dx.multiplechoice1.join('，');
      this.bus.multiplechoice2 = this.dx.multiplechoice2.join('，');
      this.bus.multiplechoice3 = this.dx.multiplechoice3.join('，');
      this.bus.multiplechoice4 = this.dx.multiplechoice4.join('，');
      this.bus.multiplechoice5 = this.dx.multiplechoice5.join('，');
      this.bus.multiplechoice6 = this.dx.multiplechoice6.join('，');
      this.bus.multiplechoice7 = this.dx.multiplechoice7.join('，');
      this.bus.multiplechoice8 = this.dx.multiplechoice8.join('，');
      console.log(this.bus, '提交的数据'); // return
      // 遮罩层

      var loading = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http.post("/ksfcustomersurvey2/save", this.bus).then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description;
        console.log(res);

        if (200 == code) {
          loading.close();
          message({
            type: "success",
            message: '提交成功！'
          });
          setTimeout(function () {
            _this6.imgStatus = true;
          }, 500); //成功后清空数据

          for (var key in _this6.bus) {
            _this6.bus[key] = '';
          }

          for (var _key in _this6.tk) {
            _this6.tk[_key] = '';
          }

          for (var _key2 in _this6.dx) {
            _this6.dx[_key2] = [];
          }

          _this6.bus.type = 3;
        } else {
          loading.close();

          for (var _key3 in _this6.bus) {
            _this6.bus[_key3] = '';
          }

          _this6.bus.type = 3;

          for (var _key4 in _this6.tk) {
            _this6.tk[_key4] = '';
          }

          for (var _key5 in _this6.dx) {
            _this6.dx[_key5] = [];
          }

          message({
            type: "error",
            message: description
          });
        }
      }).catch(function (err) {
        for (var key in _this6.bus) {
          _this6.bus[key] = '';
        }

        _this6.bus.type = 3;

        for (var _key6 in _this6.tk) {
          _this6.tk[_key6] = '';
        }

        for (var _key7 in _this6.dx) {
          _this6.dx[_key7] = [];
        }

        message({
          type: "error",
          message: '服务器错误，请联系管理员'
        });
      });
    }
  }
};